<script>
    import interface_element_translations from "./interface_element_translations.json";
    export let user_language
</script>

<a href="https://docs.google.com/forms/d/e/1FAIpQLScn0TSzYO6k1xW-Vo82iZHwLpUwcQMJWwnakSXw3NXSdkIyOA/viewform?usp=sf_link" target="_blank">{interface_element_translations["report_feedback"][user_language]}</a>